import React, { useState } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatInsideSection } from '../components/WhatInsideSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { UrgencySection } from '../components/UrgencySection';
import { FinalCTASection } from '../components/FinalCTASection';
import { TermsModal } from '../components/TermsModal';
import { PrivacyModal } from '../components/PrivacyModal';
import { ContactModal } from '../components/ContactModal';
export function SalesPage() {
  const [openModal, setOpenModal] = useState<'terms' | 'privacy' | 'contact' | null>(null);
  return <div className="min-h-screen" style={{
    backgroundColor: '#050A14',
    fontFamily: 'Inter, system-ui, sans-serif'
  }} data-id="element-281">
      <HeroSection data-id="element-282" />
      <ProblemSection data-id="element-283" />
      <SolutionSection data-id="element-284" />
      <WhatInsideSection data-id="element-285" />
      <ForWhoSection data-id="element-286" />
      <UrgencySection data-id="element-287" />
      <FinalCTASection data-id="element-288" />

      <footer className="py-12 text-center text-sm border-t" style={{
      backgroundColor: '#050A14',
      borderColor: 'rgba(14,165,233,0.1)',
      color: '#475569'
    }} data-id="element-289">
        <div className="max-w-7xl mx-auto px-4" data-id="element-290">
          <p className="mb-4" data-id="element-291">
            &copy; {new Date().getFullYear()} Arquitectos del Futuro. Todos los
            derechos reservados.
          </p>
          <div className="flex justify-center gap-6" data-id="element-292">
            <button onClick={() => setOpenModal('terms')} className="transition-colors hover:text-sky-400 cursor-pointer" style={{
            background: 'none',
            border: 'none',
            color: 'inherit',
            font: 'inherit'
          }} data-id="element-293">
              Términos de Uso
            </button>
            <button onClick={() => setOpenModal('privacy')} className="transition-colors hover:text-sky-400 cursor-pointer" style={{
            background: 'none',
            border: 'none',
            color: 'inherit',
            font: 'inherit'
          }} data-id="element-294">
              Política de Privacidad
            </button>
            
          </div>
        </div>
      </footer>

      <TermsModal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} data-id="element-295" />
      <PrivacyModal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} data-id="element-296" />
      <ContactModal isOpen={openModal === 'contact'} onClose={() => setOpenModal(null)} data-id="element-297" />
    </div>;
}